import React, {FC, useEffect, useState} from 'react';
import css from './SubscriptionComment.module.scss';
import SubscriptionHead from "../SubscriptionHead/SubscriptionHead";
import HeaderLogo from "../../../components/HeaderLogo";
import {SubscriptionSettingsTranslation} from "../interfaces/SubscriptionSettingsTranslation";
import SubscribeAgain from "./SubscribeAgain/SubscribeAgain";
import CheckSubscription from "./CheckSubscription/CheckSubscription";
import Comment from "./Comment/Comment";
import {useFetching} from "../../../hooks/useFetching";
import $api from "../../../http";
import {SubscriptionSettingsData} from "../interfaces/SubscriptionSettingsData";
import {AvailableSubscriptionGroup} from "../interfaces/Subscription";
import {Contact} from "../interfaces/Contact";
import {useQuery} from "../../../hooks/useQuery";


const SubscriptionComment: FC = () => {
    const messageId = useQuery('messageId');
    const [contact, setContact] = useState<Contact>();
    const [translate, setTranslate] = useState<SubscriptionSettingsTranslation>();
    const [subscriptions, setSubscriptions] = useState<AvailableSubscriptionGroup[]>();
    const [fetchSubscriptionData] = useFetching(async (messageId: string) => {
        const response = await $api.get<SubscriptionSettingsData>('/api/Subscription/GetUnsubscribePage', {
            params: {
                messageId
            }
        })
        const {translates, contact, availableSubscriptionGroups} = response.data;
        setTranslate(translates);
        setContact(contact);
        setSubscriptions(availableSubscriptionGroups);
    })

    useEffect(() => {
        fetchSubscriptionData(messageId);
    }, [messageId])

    return (
        <div className={css.wrapper}>
            <SubscriptionHead title={'Jooble'}/>
            <HeaderLogo className={css.headerLogo}/>
            {translate && (
                <>
                    {contact?.cancelledSubscriptions.length === subscriptions?.length && contact && subscriptions
                        ?
                        <SubscribeAgain contact={contact} countryCode={contact?.countryCode} localization={translate}/>
                        :
                        <CheckSubscription link={`https://${contact?.countryCode}.jooble.org/employer/employerpage`}
                                           title={translate.ConfigSaved} btnName={translate.GoToPersonalCabinet}/>
                    }
                    {contact && <Comment contact={contact} localization={translate}/>
                    }
                </>
            )
            }
        </div>
    );
};

export default SubscriptionComment;